import { useQuery } from '@tanstack/react-query';
import { isProprietarioProfile } from '@/helpers/accessProfileUtil';
import { getHospitalityReservationList, type HospitalityReservationListItemDTO } from '@/services/hospitality.service';
import { useToken } from '@/store/auth/tokenStore';
import { useUserProfile } from './useUserData';

const STALE_MS = 60_000;

export const useHospitalityReservationList = (panelOpen: boolean) => {
    const { token } = useToken();
    const user = useUserProfile().data;
    const isProprietario = isProprietarioProfile(user);

    return useQuery({
        queryKey: ['HospitalityReservationList', user?.userId],
        queryFn: async (): Promise<HospitalityReservationListItemDTO[]> => {
            const { items, error } = await getHospitalityReservationList();
            if (error) {
                throw new Error(error);
            }
            return (items ?? []).filter(item => item.type === 1);
        },
        enabled: Boolean(token) && isProprietario && panelOpen,
        staleTime: STALE_MS,
    });
};
